import { BaseModel } from "sjs-base-model";
import NotaModel from "./NotaModel";
export default class NoteTopicsModel extends BaseModel {
    public readonly data: NotaModel[] = [];
    public readonly pageNumber: number = 0;
    public readonly pageSize: number = 0;
    public readonly totalPages: number = 0;
    public readonly totalRecords: number = 0;

    constructor(data: Partial<NoteTopicsModel>) {
        super();

        this.update(data);
    }
}
